import { Day } from '../calendar/types'

export const firstDayOfWeek = Day.MONDAY

export const MAX_CALENDAR_MONTHS = 24
